import { jsx as I } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { RangeSelection as P } from "./RangeSelection.js";
import { useState as u, useMemo as w, useCallback as T } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { PopoverContainerSize as z } from "../../../Popover/types.js";
import B from "../../../../../core/Context/useCoreContext.js";
import { AMOUNT_MULTIPLIER as E } from "./constants.js";
import D from "../BaseFilter/BaseFilter.js";
import { isUndefined as f } from "../../../../../utils/value/is.js";
import { EMPTY_OBJECT as F } from "../../../../../utils/value/constants.js";
const d = ({ updateFilters: $, selectedCurrencies: t, availableCurrencies: m, ...x }) => {
  const { i18n: g } = B(), [y, L] = u(), [p, h] = u(), M = w(() => (t == null ? void 0 : t.length) === 1 || (m == null ? void 0 : m.length) === 1, [m == null ? void 0 : m.length, t == null ? void 0 : t.length]), S = T(
    (n, o) => {
      const A = (t == null ? void 0 : t[0]) || (m == null ? void 0 : m[0]), V = o && A ? {
        style: "currency",
        currency: A,
        currencyDisplay: "symbol"
      } : void 0;
      return n.toLocaleString(g.locale, V);
    },
    [m, g, t]
  ), U = T(
    (n) => {
      const { minAmount: o, maxAmount: A } = n ?? F;
      L({ minAmount: o, maxAmount: A }), f(o) && f(A) && h(void 0), $({
        minAmount: f(o) ? void 0 : String(Math.round(o * E)),
        maxAmount: f(A) ? void 0 : String(Math.round(A * E))
      });
    },
    [$]
  );
  if (y && (y.minAmount || y.maxAmount)) {
    const { minAmount: n, maxAmount: o } = y ?? {};
    !f(n) && !f(o) && n <= o ? h(
      `${S(n, M)} ${g.get("to").toLowerCase()} ${S(o, M)}`
    ) : !f(n) && f(o) && n >= 0 ? h(`${g.get("from")} ${S(n, M)}`) : f(n) && !f(o) ? h(`${g.get("to")} ${S(o, M)}`) : h(void 0);
  }
  return /* @__PURE__ */ I(
    D,
    {
      ...x,
      updateFilters: $,
      minAmount: x.minAmount,
      maxAmount: x.maxAmount,
      onChange: U,
      value: p,
      label: p || x.label,
      type: "text",
      containerSize: z.MEDIUM,
      selectedCurrencies: t,
      availableCurrencies: m,
      render: P
    }
  );
};
export {
  d as AmountFilter
};
